module.exports = __webpack_public_path__ + "static/media/33000024.98450092.jpg";